
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/media/video",
      function () {
        return require("private-next-pages/media/video.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/media/video"])
      });
    }
  